import Vue from 'vue'
import Router from 'vue-router'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import store from './store/store'
import Home from './views/Home.vue'
import Login from './views/Login.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/projetos',
      name: 'projetos',
      component: () => import('./views/NewProjetos.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/projetos/cadastro',
      name: 'cadastro projeto',
      component: () => import('./components/projeto/Cadastro.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/projetos/:id',
      name: 'altera projeto',
      component: () => import('./components/projeto/Cadastro.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/atividades',
      name: 'atividades',
      component: () => import('./views/NewAtividades.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/atividadesocorrencias',
      name: 'atividadesocorrencias',
      component: () => import('./views/AtividadesOcorrencias.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/atividades/cadastro',
      name: 'cadastro atividade',
      component: () => import('./components/atividade/Cadastro.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/atividades/:id',
      name: 'altera atividade',
      component: () => import('./components/atividade/Cadastro.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/notificacoes',
      name: 'notificacoes',
      component: () => import('./views/Notificacoes.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/helpdesk',
      name: 'helpdesk',
      component: () => import('./views/Helpdesk.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sqls',
      name: 'sql',
      component: () => import('./views/Sqls.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/layoutssql',
      name: 'layoutSql',
      component: () => import('./views/LayoutsSql.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bairros',
      name: 'bairros',
      component: () => import('./views/Bairros.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: () => import('./views/Clientes.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/usuarios',
      name: 'usuarios',
      component: () => import('./views/Usuarios.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/usuario/:id/perfil',
      name: 'perfil',
      component: () => import('./views/UsuarioPerfil.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/colaboradores',
      name: 'colaboradores',
      component: () => import('./views/Colaboradores.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/prioridades',
      name: 'prioridades',
      component: () => import('./views/Prioridades.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tiposocorrencia',
      name: 'tiposOcorrencia',
      component: () => import('./views/TiposOcorrencia.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tipossituacao',
      name: 'tiposSituacao',
      component: () => import('./views/TiposSituacao.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tiposcolaborador',
      name: 'tiposColaborador',
      component: () => import('./views/TiposColaborador.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tiposprojeto',
      name: 'tiposProjeto',
      component: () => import('./views/TiposProjeto.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tiposatividade',
      name: 'tiposAtividade',
      component: () => import('./views/TiposAtividade.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/modelosatividade',
      name: 'modelosAtividade',
      component: () => import('./views/ModelosAtividade.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/modelosocorrencia',
      name: 'modelosOcorrencia',
      component: () => import('./views/ModelosOcorrencia.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/situacoes',
      name: 'situacoes',
      component: () => import('./views/Situacoes.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tags',
      name: 'tags',
      component: () => import('./views/Tags.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/equipes',
      name: 'equipes',
      component: () => import('./views/Equipes.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/workflows',
      name: 'workflows',
      component: () => import('./views/Workflows.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/motivos',
      name: 'motivos',
      component: () => import('./views/Motivos.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/testdragdrop',
      name: 'TestDragDrop',
      component: () => import('./views/TestDragDrop.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.authenticated) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router